import React, { useState, useRef, useCallback, useEffect } from "react";
import RecipeBuilder from "../RecipeBuilder";
import { MessageCircle, X, ChefHat } from "lucide-react";
import { images } from '../../assets/images';
import "./ChatRecipeWidget.css";
import LunchRecipeBuilder from "../LunchReceipeBuilder/LunchRecipeBuilder";

function ChatRecipeWidget({ onSelectRecipe, startOpen = false }) {
  const [isOpen, setIsOpen] = useState(startOpen);
  const [hasOpenedOnce, setHasOpenedOnce] = useState(startOpen);
  const [showBanner, setShowBanner] = useState(true);
  const bodyRef = useRef(null);

  // RecipeBuilder expects a scrollToTop callback (normally scrolls the
  // page's TopBar into view). Inside the popup we just scroll the
  // popup's own body back to the top on step changes.
  const scrollToTop = useCallback(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  const handleOpen = () => {
    setIsOpen(true);
    setHasOpenedOnce(true);
  };

  const handleClose = () => setIsOpen(false);

  const handleSelectRecipe = (recipe) => {
    if (onSelectRecipe) onSelectRecipe(recipe);
  };

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") handleClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen]);

  return (
    <>
      <button
        className={`chat-recipe-fab ${isOpen ? "is-open" : ""}`}
        onClick={isOpen ? handleClose : handleOpen}
        type="button"
        aria-label={isOpen ? "Close recipe assistant" : "Open recipe assistant"}
        aria-expanded={isOpen}
      >
        {isOpen ? (
          <X size={26} strokeWidth={2.25} />
        ) : (
          <img
            src={images.knorrLunchLogo}
            alt="Ramadan Recipe Builder"
            className="lunch__logo"
          />
        )}
      </button>

      <div
        className={`chat-recipe-overlay ${isOpen ? "is-open" : ""}`}
        onClick={handleClose}
        aria-hidden={!isOpen}
      >
        <div
          className="chat-recipe-popup"
          role="dialog"
          aria-modal="true"
          aria-label="Knorr Recipe AI assistant"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="chat-recipe-header">
            <div className="chat-recipe-header-title">
              <span className="chat-recipe-avatar">
                <ChefHat size={18} strokeWidth={2} />
              </span>
              <div className="chat-recipe-header-text">
                <span className="chat-recipe-header-name">Knorr Recipe AI</span>
                <span className="chat-recipe-header-status">
                  <span className="chat-recipe-dot" />
                  Online
                </span>
              </div>
            </div>
            <button
              className="chat-recipe-close"
              onClick={handleClose}
              type="button"
              aria-label="Close"
            >
              <X size={20} strokeWidth={2} />
            </button>
          </div>

          <div className="chat-recipe-body" ref={bodyRef}>
            {hasOpenedOnce && (
              <LunchRecipeBuilder
                onSelectRecipe={handleSelectRecipe}
                setShowBanner={setShowBanner}
                scrollToTop={scrollToTop}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ChatRecipeWidget;
